<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Shop.Fields.configsList") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
       <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="options.keyword"
              @text="KeyWord = $event"
              :label="
                $t('Material.materialNameAndCodeKeyword') 
              "
            />
          </v-row>
        </v-col>
         <v-col cols="12" sm="2" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="caption font-weight-bold grey--text"
                color="primary"
                @click.stop="onSearch()"
              >
                <v-icon small class="pe-1">fa-search</v-icon>
                {{ $t("Search.search") }}
              </v-btn>
            </template>
            <span>{{ $t("Search.searchTip") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-data-table
        :headers="Headers"
        :items="materials"
        :loading="loading"
        :options.sync="options"
        :page.sync="paging.page"
        :server-items-length="paging.count"
        multi-sort
        class="elevation-0 px-6"
        height="380px"
        fixed-header
        :footer-props="$t('$config.footer-props')"
      >
        
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Shops from "@/api/shops";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";


export default {
  name: "SubAccountConfigsDialog",

  props: {
    value: Boolean,
    shopId: Number,
    stockId: String,
  },

   components: {
    SearcherKeyword,
  },

  computed: {
    Headers() {
      return [
        {
          text: i18n.t("Material.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("Material.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material.material_name",
        },
        {
          text: i18n.t("Material.Fields.material_category"),
          align: "start",
          sortable: false,
          value: "material.material_category.name",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    materials: [],
    paging: {},
    options: {},
    KeyWord: "",
  }),

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {keyword:this.KeyWord})
    },
    getSockDistributionConfigsMaterials() {
      Shops.getSockDistributionConfigsMaterials(Object.assign(this.options,{
        shop_id: this.shopId,
        stock_id: this.stockId,
      })).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.validDistributionCenterConfigs;
            this.paging = response.data.paging
          }
        }.bind(this)
      );
    },
  
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.shopId && this.stockId) { 
          this.getSockDistributionConfigsMaterials();
        }
          
        if (this.value) {
          this.dialog = this.value;
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.materials = [];
          this.KeyWord = ""
          this.$refs.keyword.clear()
          this.paging.page = 1
          this.options.keyword = ""
        }
        this.$emit("input", this.dialog);
      },
    },
    options: {
      deep:true,
      handler() { 
        if (this.shopId && this.stockId) { 
          this.getSockDistributionConfigsMaterials();
        }
      }
    },
    shopId: {
      handler() { 
        if (this.shopId && this.stockId) { 
          this.getSockDistributionConfigsMaterials();
        }
      }
    },
    stockId: {
      handler() { 
        if (this.shopId && this.stockId) { 
          this.getSockDistributionConfigsMaterials();
        }
      }
    }
  },
};
</script>